/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import { useEffect, useState } from "react";

/**
 * Returns the current contact's state
 */
export const useCurrentContactState = () => {
	const [contactState, setContactState] = useState(null);
	const [currentAgent, setCurrentAgent] = useState(null);

	useEffect(() => {
		if (!currentAgent) {
			return;
		}

		const contact = currentAgent.getContacts().find((contact) => contact.contactId === window.paceCurrentContactId);
		if (contact) {
			setContactState(contact.getState().type);
		}
	}, [currentAgent]);

	useEffect(() => {
		const agentSubscription = window.connect.agent(async (agent) => {
			setCurrentAgent(agent);
		});

		return () => {
			agentSubscription.unsubscribe();
		};
	}, []);

	useEffect(() => {
		if (!currentAgent) {
			return;
		}

		const events = window.connect.core.getEventBus();
		const eventTypes = ["CONNECTED", "ENDED", "VIEW"];
		const eventSubscriptions = eventTypes.map((type) => {
			return events.subscribe(window.connect.ContactEvents[type], (event) => {
				if (event.contactId === "") {
					setContactState(null);
				} else {
					const contact = currentAgent.getContacts().find((contact) => contact.contactId === event.contactId);
					if (contact) {
						setContactState(contact.getState().type);
					}
				}
			});
		});

		return () => {
			eventSubscriptions.forEach((sub) => sub.unsubscribe());
		};
	}, [currentAgent]);

	return contactState;
};
